import React, { Suspense, lazy } from 'react';
import Layout from './components/Layout';
import About from './components/About/About';
import NotFound from './components/NotFound';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './style.scss';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; 

const Home = lazy(() => import('./components/Home'));
const CountryFullFinInfo = lazy(() => import('./components/FullFinInfo/CountryFullFinInfo'));

const App = () => (
  <>
    <Helmet>
      <meta charSet="utf-8" />‍
      <title>World economic book.</title>‍
      <meta name="description" content="Statistic overview of economic development of countries" />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Anton Nalyvaiko" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="keywords" content="GDP, Gross domestic product, Balance of Payments, BOP, CPI, Consumer Price Index, Producer Price Index, Inflation" />
    </Helmet>
    <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
    <I18nextProvider i18n={ i18n }>
      <Layout>
          <Routes >
            <Route exact path='/' element={<Home />} />
            <Route path="/countries/:code"  element={<CountryFullFinInfo />}   />
            <Route path='/About' element={<About />} />
            <Route path='*' element={<NotFound />} />
          </Routes >
      </Layout>
      </I18nextProvider>
    </Suspense>
    </React.StrictMode>
  </>
);
export default App;